(function () {
  // Run once per page. The Order page prints this script twice (Start
  // Here's grid via makc-menu-grid.liquid, and makc-order-most-loved.
  // liquid), and a browser runs each tag -- without this every listener
  // below was bound twice: the stepper jumped by 2 and one Add to order
  // tap sent two adds (confirmed on staging 2026-09-19). One run already
  // binds every sheet and trigger on the page, so the second is a no-op.
  if (window.makcProductSheetLoaded) return;
  window.makcProductSheetLoaded = true;

  var sheets = Array.prototype.slice.call(document.querySelectorAll('[data-makc-product-sheet]'));
  if (!sheets.length) return;

  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-makc-product-sheet-trigger]'));
  if (!triggers.length) return;

  var openSheet = null;

  function findSheet(productId) {
    return sheets.filter(function (sheet) {
      return sheet.getAttribute('data-product-id') === productId;
    })[0];
  }

  // Scroll-lock lives in the shared assets/makc-scroll-lock.js, loaded
  // once from sections/makc-menu.liquid before this script -- see that
  // file for why it's shared rather than a local implementation here.
  //
  // Locked decision: the grid always opens a fresh, unconfigured sheet,
  // regardless of what's already in the cart for this product or what
  // was left selected/typed the last time it was open -- resetSheet()
  // (defined below, alongside the state it's resetting) runs on every
  // open, not just after a successful add, since a plain X-close should
  // reset just as much as a completed add does.
  // prepare (optional) runs after the reset and BEFORE the sheet is
  // unhidden, which is the whole point of it: edit mode used to
  // preload the line's configuration after open() had already unhidden
  // the sheet. Both ran in one task, so the first painted frame was
  // always correct -- but preloading expands the modifier groups it
  // fills, and those groups animate (grid-template-rows, see assets/
  // makc-product-sheet.css). Expanded while the sheet is still
  // display:none, they have no before-change style and simply start
  // open; expanded after, they animate open underneath the sheet's own
  // entrance. Sweep item 1 from the toolbar-bug follow-ups, and the
  // same rule as the cart pill's text: write content before unhiding
  // (CLAUDE.md "Motion").
  function open(sheet, prepare) {
    if (openSheet && openSheet !== sheet) openSheet.hidden = true;
    if (!openSheet) window.makcScrollLock.lock();
    exitEditMode(sheet);
    resetSheet(sheet);
    if (prepare) prepare(sheet);
    sheet.hidden = false;
    openSheet = sheet;
  }

  // The sheet now fades out over --makc-duration-enter (assets/
  // makc-product-sheet.css), so it is still on screen for 200ms after
  // hidden is set. Anything visible has to wait for that to finish:
  // exitEditMode reverts the bottom bar from "Update - $X" to "Add to
  // order", and unlocking scroll immediately lets the page behind jump
  // back to its restored position while the sheet is still fading.
  // CLAUDE.md "Motion": clear it after the exit ends.
  //
  // openSheet is cleared synchronously because it is bookkeeping, not
  // pixels -- a second open must not think this sheet is still current.
  // The unlock runs unconditionally once scheduled (skipping it on a
  // reopen would strand a lock and leave the page unscrollable), while
  // the visible teardown is skipped if the sheet came back.
  function close(sheet) {
    sheet.hidden = true;
    var wasOpen = openSheet === sheet;
    if (wasOpen) openSheet = null;
    function tail() {
      if (wasOpen) window.makcScrollLock.unlock();
      if (sheet.hidden) exitEditMode(sheet);
    }
    if (window.makcOverlayExit) window.makcOverlayExit.after(sheet, tail);
    else tail();
  }

  // ---- Edit mode (Paper: Cart Shell / Edit Item / Proposed / Sheet) ----
  //
  // The same sheet, opened from a cart line instead of a card, with that
  // line's selections preloaded, no quantity control (the line keeps its
  // quantity; the cart row's stepper owns quantity) and the bottom bar
  // reading "Update · $X", X = unit price x the line's quantity. Update
  // hands the new configuration to the cart shell's replaceLine (add
  // the new line, then remove the old one -- see assets/makc-cart-
  // shell.js), which reopens the shell on success; the close X abandons
  // with no write. Mode lives on the sheet root as data-makc-sheet-mode
  // ="edit" (CSS hides the stepper) plus data-edit-quantity, and the
  // line itself as sheet.__makcEditLine; every open() and close() clears
  // all three, so a card tap after an abandoned edit is a plain fresh
  // open.
  function enterEditMode(sheet, line) {
    sheet.setAttribute('data-makc-sheet-mode', 'edit');
    sheet.setAttribute('data-edit-quantity', String(line.quantity || 1));
    sheet.__makcEditLine = line;
  }

  function exitEditMode(sheet) {
    sheet.removeAttribute('data-makc-sheet-mode');
    sheet.removeAttribute('data-edit-quantity');
    sheet.__makcEditLine = null;
  }

  function isEditing(sheet) {
    return sheet.getAttribute('data-makc-sheet-mode') === 'edit';
  }

  function editQuantity(sheet) {
    return parseInt(sheet.getAttribute('data-edit-quantity'), 10) || 1;
  }

  function radioWithValue(radios, value) {
    return Array.prototype.filter.call(radios, function (radio) {
      return radio.value === value;
    })[0] || null;
  }

  // A group whose option was preloaded is shown expanded, so the
  // customer sees what they chose without hunting through collapsed
  // Optional accordions.
  function expandGroupOf(element) {
    var group = element.closest('.makc-product-sheet__modifier-group');
    var header = group ? group.querySelector('.makc-product-sheet__modifier-header') : null;
    if (header) header.setAttribute('aria-expanded', 'true');
  }

  // Preload order matters: the variant first (single-option: the radio
  // whose value is the line's variant_id; two-option: one radio per
  // option group from options_with_values, then the same matrix
  // resolution a live change would run), then filterScopedOptions for
  // the chosen option value so scoped modifier options are visible
  // BEFORE their radios are checked (a hidden radio is never left
  // checked -- that invariant is enforced on every change), then each
  // modifier group's radio matching line.properties by group name and
  // value, then Special instructions (preloaded here even though the
  // cart summary leaves it out -- it is still part of the line), then
  // the price/label. Compared by .value, not by attribute selector, so
  // option text needs no CSS escaping.
  function preloadFromLine(sheet, line) {
    var variantRadio = radioWithValue(
      sheet.querySelectorAll('.makc-product-sheet__modifier-radio[data-option-value]'),
      String(line.variant_id)
    );
    if (variantRadio && !variantRadio.disabled) {
      variantRadio.checked = true;
      filterScopedOptions(sheet, variantRadio.getAttribute('data-option-value'));
    } else if (line.options_with_values && sheet.querySelector('[data-makc-resolved-variant]')) {
      line.options_with_values.forEach(function (option, index) {
        var group = sheet.querySelector('[data-variant-option-group="' + (index + 1) + '"]');
        if (!group) return;
        var radio = radioWithValue(group.querySelectorAll('.makc-product-sheet__modifier-radio'), option.value);
        if (radio && !radio.disabled) radio.checked = true;
      });
      resolveMultiOptionVariant(sheet);
    }

    var properties = line.properties || {};
    sheet.querySelectorAll('[data-modifier-group]').forEach(function (group) {
      var value = properties[group.getAttribute('data-modifier-group')];
      if (!value) return;
      var radio = radioWithValue(group.querySelectorAll('.makc-product-sheet__modifier-radio'), value);
      if (!radio) return;
      var option = radio.closest('.makc-product-sheet__modifier-option');
      if (option && option.hidden) return;
      radio.checked = true;
      expandGroupOf(radio);
    });

    var instructionsInput = sheet.querySelector('[data-makc-instructions-input]');
    if (instructionsInput && properties['Special instructions']) {
      instructionsInput.value = properties['Special instructions'];
      var counter = instructionsInput.parentElement.querySelector('[data-makc-instructions-counter]');
      if (counter) counter.textContent = instructionsInput.value.length + '/' + instructionsInput.getAttribute('maxlength');
      expandGroupOf(instructionsInput);
    }

    updateAddButtonPrice(sheet);
  }

  // Returns whether a sheet for the line's product exists on this page
  // (the caller reopens the cart shell if not).
  function openForEdit(line) {
    var sheet = findSheet(String(line.product_id));
    if (!sheet) return false;
    open(sheet, function (target) {
      enterEditMode(target, line);
      preloadFromLine(target, line);
    });
    return true;
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var sheet = findSheet(trigger.getAttribute('data-makc-product-sheet-trigger'));
      if (sheet) open(sheet);
    });
  });

  // Sheet-image warming. The sheet's <img> is loading="lazy" inside a
  // hidden sheet, and a lazy image that never intersects the viewport
  // never fetches -- so on open the hero area painted empty and the
  // image arrived a beat later (small-fixes item 2). Fetching every
  // sheet image up front would cost ~44 x 780px renders on a Menu
  // load, most never opened; instead a product's sheet image is
  // switched to eager once that product's own CARD image has loaded,
  // i.e. once the card has actually scrolled into view (card images
  // are lazy too, in both snippets/makc-menu-card.liquid and snippets/
  // makc-order-row-card.liquid, so their load event is the "this card
  // is on screen" signal). A card image already complete at init
  // (cached, or above the fold on a fast connection) warms straight
  // away. Cards with no image never warm; their sheet has no image
  // either. Flipping .loading on a lazy image whose fetch has not
  // started makes the browser start it, hidden or not.
  function warmSheetImage(productId) {
    var sheet = findSheet(productId);
    var image = sheet && sheet.querySelector('.makc-product-sheet__image-el');
    if (image && image.loading === 'lazy') image.loading = 'eager';
  }

  triggers.forEach(function (trigger) {
    var card = trigger.closest('.makc-menu-card, .makc-order-row-card');
    var cardImage = card && card.querySelector('img');
    if (!cardImage) return;
    var productId = trigger.getAttribute('data-makc-product-sheet-trigger');
    if (cardImage.complete && cardImage.naturalWidth > 0) {
      warmSheetImage(productId);
    } else {
      cardImage.addEventListener('load', function () {
        warmSheetImage(productId);
      }, { once: true });
    }
  });

  // Exposes the exact same findSheet()/open() above for a second caller
  // that can't use the static trigger-wiring pattern: assets/makc-
  // search-takeover.js's search result rows are created dynamically,
  // after this file's own one-time triggers querySelectorAll has
  // already run, so a data-makc-product-sheet-trigger attribute on a
  // row created later would never get a listener attached. Matches the
  // established window.makcScrollLock/window.makcCart/window.
  // makcFilters convention for cross-file shared state rather than a
  // new pattern. Returns whether a matching sheet was actually found
  // and opened -- this file only ever loads on the Menu page (see
  // snippets/makc-product-sheet.liquid's own comment: loaded once from
  // makc-menu-grid.liquid), so window.makcProductSheet is never even
  // defined on other pages; the caller uses the return value to no-op
  // gracefully rather than assuming a sheet always exists.
  // hasSheet: the cart shell asks this before starting an edit on the
  // current page -- this script loads on any page that renders menu
  // cards (Menu, and the Order page's own rows), but each page only
  // renders sheets for the products on it, so "script present" is not
  // "sheet present" for a given line.
  window.makcProductSheet = {
    open: function (productId) {
      var sheet = findSheet(productId);
      if (sheet) open(sheet);
      return !!sheet;
    },
    hasSheet: function (productId) {
      return !!findSheet(String(productId));
    },
    openForEdit: openForEdit
  };

  // Deep-link receiving end: a search result tapped from a non-Menu
  // page redirects here with ?open=<product id> (assets/makc-search-
  // takeover.js's own openProductSheet() sets this -- see that file's
  // and the liquid template's own comments for the full identifier/URL
  // reasoning). Runs synchronously right here, immediately after
  // window.makcProductSheet is defined above, in the same script --
  // not a separate file/listener -- so there's no cross-file load-order
  // race: window.makcProductSheet already exists by construction at
  // this point, and this reuses that exact same open(), not a second
  // implementation. Fails gracefully for a bad/missing/sold-out
  // (no-sheet-rendered) id: open() returns false, nothing else happens,
  // the Menu page just loads normally with no error. The parameter is
  // always stripped via history.replaceState once checked, success or
  // not -- confirmed as the right call: this is a one-time "arrived via
  // a search tap" signal, not a deliberately shareable/bookmarkable
  // always-reopens-this-sheet link (nothing in this build has asked for
  // that), so leaving it in the URL would be an unintended side effect.
  // Only the "open" key is removed (not the whole query string), so any
  // other real query param on this page load is left untouched.
  var deepLinkProductId = new URLSearchParams(window.location.search).get('open');
  if (deepLinkProductId) {
    window.makcProductSheet.open(deepLinkProductId);
    var remainingParams = new URLSearchParams(window.location.search);
    remainingParams.delete('open');
    var remainingSearch = remainingParams.toString();
    var cleanUrl = window.location.pathname + (remainingSearch ? '?' + remainingSearch : '') + window.location.hash;
    window.history.replaceState(null, '', cleanUrl);
  }

  // Edit deep link: ?edit=<cart line key>, set by the cart shell when a
  // line is tapped off the Menu page (assets/makc-cart-shell.js
  // beginLineEdit). Consumed and stripped exactly like ?open= above.
  // The line itself has to come from the cart: this script runs before
  // assets/makc-cart.js in document order (both deferred), so the read
  // has to wait until window.makcCart exists. Deferred scripts execute
  // after parsing and BEFORE DOMContentLoaded, while document.readyState
  // is already "interactive" -- so a readyState === "loading" check is
  // false here and would run the read immediately, find no makcCart,
  // and silently open nothing (the 2026-09-15 homepage / Our Story
  // sighting). The rule is therefore: read now if makcCart already
  // exists, otherwise wait for DOMContentLoaded, by which point every
  // deferred script has run. Asks Shopify for the current cart rather
  // than trusting any cached copy. A key that no longer exists (the
  // line was removed or re-keyed in between) opens nothing -- the Menu
  // page just loads normally, same failure posture as a bad ?open= id.
  // One info line per arrival states the key and whether a line
  // matched, so a field report can be read from the console.
  var editLineKey = new URLSearchParams(window.location.search).get('edit');
  if (editLineKey) {
    var paramsAfterEdit = new URLSearchParams(window.location.search);
    paramsAfterEdit.delete('edit');
    var searchAfterEdit = paramsAfterEdit.toString();
    window.history.replaceState(null, '', window.location.pathname + (searchAfterEdit ? '?' + searchAfterEdit : '') + window.location.hash);

    var receiveEditDeepLink = function () {
      if (!window.makcCart || !window.makcCart.getCart) {
        console.warn('[makc-product-sheet] ?edit= deep link: window.makcCart is not available, opening the Menu page normally', { key: editLineKey });
        return;
      }
      window.makcCart.getCart().then(function (cart) {
        var line = (cart.items || []).filter(function (item) {
          return item.key === editLineKey;
        })[0];
        console.info('[makc-product-sheet] ?edit= deep link', { key: editLineKey, lineFound: !!line, sheetFound: line ? !!findSheet(String(line.product_id)) : null });
        if (line) openForEdit(line);
      }).catch(function (error) {
        console.warn('[makc-product-sheet] ?edit= deep link: cart could not be read, opening the Menu page normally', { key: editLineKey }, error);
      });
    };
    if (window.makcCart && window.makcCart.getCart) {
      receiveEditDeepLink();
    } else if (document.readyState === 'complete') {
      receiveEditDeepLink();
    } else {
      document.addEventListener('DOMContentLoaded', receiveEditDeepLink);
    }
  }

  // Shared by both dismissal affordances: the close X, and the backdrop
  // click wired below (768px and up, where the sheet is a centred
  // modal). In edit mode either one is "abandon": nothing is written,
  // and the customer is handed back to the cart shell they came from,
  // the same landing Update gives. A fresh card-tap open just closes.
  // isEditing is read BEFORE close(), which clears edit mode.
  function dismiss(sheet) {
    var abandoningEdit = isEditing(sheet);
    close(sheet);
    if (abandoningEdit && window.makcCartShell && window.makcCartShell.open) {
      window.makcCartShell.open();
    }
  }

  sheets.forEach(function (sheet) {
    var closeButton = sheet.querySelector('[data-makc-product-sheet-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        dismiss(sheet);
      });
    }

    // Backdrop dismiss: the same second affordance the filter modal has,
    // for the centred modal this becomes at 768px and up. Bound to the
    // real backdrop element (display: none below 768, so it cannot be
    // clicked there) rather than inferred from the click target -- the
    // earlier version listened on the sheet root and dismissed whenever
    // the target WAS the root, which turned every dead spot in the card
    // into a dismiss trigger the moment the backdrop painted over the
    // content. Dismissal is identical to the X, edit mode included.
    var backdrop = sheet.querySelector('[data-makc-product-sheet-backdrop]');
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        dismiss(sheet);
      });
    }
  });

  // Add to order price = quantity x unit price -- unit price is the
  // selected variant's own price (data-variant-price-cents) if one is
  // currently chosen, else the Add button's own data-unit-price
  // (product.price, the same value already server-rendered as its
  // starting text). Shared by both the stepper and variant-change
  // listeners below, since either one can change the total.
  // In edit mode the quantity is the cart line's own (data-edit-
  // quantity, the stepper is hidden) and the label reads "Update · $X".
  function updateAddButtonPrice(sheetEl) {
    var addButton = sheetEl.querySelector('[data-makc-product-sheet-add]');
    var countEl = sheetEl.querySelector('[data-makc-stepper-count]');
    if (!addButton || !countEl) return;
    var editing = isEditing(sheetEl);
    var quantity = editing ? editQuantity(sheetEl) : (parseInt(countEl.textContent, 10) || 1);
    var selectedVariant = sheetEl.querySelector('.makc-product-sheet__modifier-radio[data-variant-price-cents]:checked');
    var unitPriceCents = selectedVariant
      ? parseInt(selectedVariant.getAttribute('data-variant-price-cents'), 10)
      : parseInt(addButton.getAttribute('data-unit-price'), 10);
    addButton.textContent = (editing ? 'Update · ' : 'Add to order · ') + window.makcCart.formatMoney(unitPriceCents * quantity);
  }

  // Quantity stepper -- min 1, uncapped. The real inventory check
  // happens server-side at /cart/add.js, the sole source of truth per
  // the confirmed decision: a client-side cap would only reflect
  // inventory as of page load and could already be stale by the time
  // of a real add, given concurrent customers, so it's not built here.
  var steppers = document.querySelectorAll('.makc-product-sheet__stepper');
  steppers.forEach(function (stepper) {
    var sheetEl = stepper.closest('.makc-product-sheet');
    var countEl = stepper.querySelector('[data-makc-stepper-count]');
    var decreaseButton = stepper.querySelector('[data-makc-stepper-decrease]');
    var increaseButton = stepper.querySelector('[data-makc-stepper-increase]');
    if (!sheetEl || !countEl) return;

    decreaseButton.addEventListener('click', function () {
      var quantity = parseInt(countEl.textContent, 10) || 1;
      if (quantity <= 1) return;
      countEl.textContent = String(quantity - 1);
      updateAddButtonPrice(sheetEl);
    });

    increaseButton.addEventListener('click', function () {
      var quantity = parseInt(countEl.textContent, 10) || 1;
      countEl.textContent = String(quantity + 1);
      updateAddButtonPrice(sheetEl);
    });
  });

  // Required-field validation -- confirmed via inspection that nothing
  // native currently blocks this (no radio carries the HTML required
  // attribute, the sheet has no <form>, and the Add button is
  // type="button" with a click listener, not type="submit", so browser
  // constraint validation never runs here). data-required is rendered
  // server-side on every group needing a selection (see the liquid
  // template). A group counts as satisfied purely by having a checked
  // radio -- relies on the existing invariant enforced by the
  // cross-group dependency logic below (a hidden radio is never left
  // checked), so no redundant :not([hidden]) guard is needed here. This
  // also covers the Size -> Protein dependency (Jollof Rice Tray with
  // Protein) with no special-casing: Protein can't have a checked,
  // visible option until a Size is chosen first, so requiring "a
  // checked radio in every data-required group" already requires both.
  function getUnsatisfiedRequiredGroups(sheetEl) {
    var requiredGroups = sheetEl.querySelectorAll('.makc-product-sheet__modifier-group[data-required]');
    return Array.prototype.filter.call(requiredGroups, function (group) {
      return !group.querySelector('.makc-product-sheet__modifier-radio:checked');
    });
  }

  function setValidationState(sheetEl, unsatisfiedGroups) {
    var errorEl = sheetEl.querySelector('[data-makc-validation-error]');
    sheetEl.querySelectorAll('.makc-product-sheet__modifier-group[data-required]').forEach(function (group) {
      group.removeAttribute('data-invalid');
    });
    unsatisfiedGroups.forEach(function (group) {
      group.setAttribute('data-invalid', '');
    });
    if (errorEl) errorEl.hidden = unsatisfiedGroups.length === 0;
  }

  // Real /cart/add.js submission. Variant id: the selected variant
  // radio's own value when a variant group renders, else the Add
  // button's own data-default-variant-id (product.selected_or_first_
  // available_variant.id, server-rendered -- correct for every product
  // in today's real catalogue, since a variant group only ever fails
  // to render for a single-variant product; a hypothetical future
  // multi-option product with no picker yet is an already-accepted,
  // pre-existing scope gap, not something new here). Properties:
  // one entry per [data-modifier-group] (custom groups only -- the
  // variant group deliberately excluded, since its own selection IS
  // the variant, not a separate property) that currently has a checked
  // radio, keyed by that group's own name, plus "Special instructions"
  // only when the field is non-blank after trimming (never sent empty).
  var addButtons = document.querySelectorAll('[data-makc-product-sheet-add]');
  addButtons.forEach(function (addButton) {
    addButton.addEventListener('click', function () {
      var sheetEl = addButton.closest('.makc-product-sheet');
      if (!sheetEl) return;
      var unsatisfiedGroups = getUnsatisfiedRequiredGroups(sheetEl);
      setValidationState(sheetEl, unsatisfiedGroups);
      if (unsatisfiedGroups.length > 0) {
        unsatisfiedGroups[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var cartErrorEl = sheetEl.querySelector('[data-makc-cart-error]');
      if (cartErrorEl) cartErrorEl.hidden = true;

      var countEl = sheetEl.querySelector('[data-makc-stepper-count]');
      var quantity = parseInt(countEl.textContent, 10) || 1;
      var selectedVariant = sheetEl.querySelector('.makc-product-sheet__modifier-radio[data-variant-price-cents]:checked');
      var variantId = selectedVariant ? selectedVariant.value : addButton.getAttribute('data-default-variant-id');

      var properties = {};
      sheetEl.querySelectorAll('[data-modifier-group]').forEach(function (group) {
        var checkedRadio = group.querySelector('.makc-product-sheet__modifier-radio:checked');
        if (checkedRadio) properties[group.getAttribute('data-modifier-group')] = checkedRadio.value;
      });
      var instructionsInput = sheetEl.querySelector('[data-makc-instructions-input]');
      if (instructionsInput && instructionsInput.value.trim() !== '') {
        properties['Special instructions'] = instructionsInput.value.trim();
      }

      var normalButtonText = addButton.textContent;

      // Edit mode: the same payload shape, the line's own quantity, and
      // the cart shell's replaceLine instead of a plain add -- it adds
      // the new configuration, removes the old line and reopens the
      // shell itself on success (see its own comment for the failure
      // split). This sheet only closes on success; an add-stage failure
      // is shown here and nothing in the cart has changed.
      var editLine = sheetEl.__makcEditLine;
      if (editLine) {
        if (!window.makcCartShell || !window.makcCartShell.replaceLine) {
          if (cartErrorEl) {
            cartErrorEl.textContent = 'Something went wrong — please try again.';
            cartErrorEl.hidden = false;
          }
          return;
        }
        addButton.disabled = true;
        addButton.textContent = 'Updating…';
        window.makcCartShell.replaceLine(editLine.key, { id: variantId, quantity: editQuantity(sheetEl), properties: properties }).then(function (result) {
          addButton.disabled = false;
          if (result.ok) {
            close(sheetEl);
            return;
          }
          addButton.textContent = normalButtonText;
          if (!cartErrorEl) return;
          var editMessage = (result.data && (result.data.description || result.data.message)) || 'Something went wrong — please try again.';
          cartErrorEl.textContent = editMessage;
          cartErrorEl.hidden = false;
        });
        return;
      }

      addButton.disabled = true;
      addButton.textContent = 'Adding…';
      window.makcCart.addToCart([{ id: variantId, quantity: quantity, properties: properties }]).then(function (result) {
        addButton.disabled = false;
        if (result.ok) {
          window.makcCart.refreshCartUI();
          close(sheetEl);
          return;
        }
        // Sheet only closes on success, so this restore is the one
        // path that's actually seen -- the inline error below already
        // covers the failure reason, this just puts the button itself
        // back to normal rather than leaving it stuck on "Adding…".
        addButton.textContent = normalButtonText;
        if (!cartErrorEl) return;
        var message = (result.data && (result.data.description || result.data.message)) || 'Something went wrong — please try again.';
        cartErrorEl.textContent = message;
        cartErrorEl.hidden = false;
      });
    });
  });

  // Clears a group's invalid highlight as soon as it becomes satisfied
  // (e.g. the customer picks the missing option), rather than only on
  // the next Add-tap -- but only ever clears, never proactively flags
  // a group that hasn't been tapped-and-found-invalid yet, so browsing
  // the sheet alone never triggers an error state on its own.
  sheets.forEach(function (sheet) {
    sheet.addEventListener('change', function (event) {
      if (!event.target.classList.contains('makc-product-sheet__modifier-radio')) return;
      var stillUnsatisfied = getUnsatisfiedRequiredGroups(sheet).filter(function (group) {
        return group.hasAttribute('data-invalid');
      });
      setValidationState(sheet, stillUnsatisfied);
    });
  });

  // Modifier group accordion -- same simple toggle as the footer's own
  // accordion (assets/makc-footer.js): aria-expanded is server-rendered
  // to the correct initial state (Required expanded, Optional
  // collapsed), this just flips it on click. No desktop/mobile
  // interactivity split like the footer's needs, since this sheet is
  // mobile-only throughout.
  var modifierHeaders = document.querySelectorAll('.makc-product-sheet__modifier-header');
  modifierHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
      var expanded = header.getAttribute('aria-expanded') === 'true';
      header.setAttribute('aria-expanded', String(!expanded));
    });
  });

  // Variant price reactivity -- only radios carrying
  // data-variant-price-cents are real Shopify variants (custom
  // modifier options never have this attribute, since those are
  // confirmed free choices with no pricing). Recomputes via the shared
  // updateAddButtonPrice above, which also folds in the current
  // quantity -- not a direct string set, since either input can change
  // the total. Single-option products only: deliberately doesn't
  // attempt combinatorial matching across multiple option positions,
  // since that's a later step (see snippets/makc-product-sheet.liquid)
  // -- the liquid template itself only renders a variant group at all
  // for single-option products, so this only ever runs against that
  // case.
  var variantRadios = document.querySelectorAll('.makc-product-sheet__modifier-radio[data-variant-price-cents]');
  variantRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var sheetEl = radio.closest('.makc-product-sheet');
      if (!sheetEl) return;
      updateAddButtonPrice(sheetEl);
    });
  });

  // ---- Multi-option variant matching (2-option products only) -------
  //
  // Deliberately separate from the single-option variant-radio logic
  // above, not a generalization of it -- see snippets/makc-product-
  // sheet.liquid's own comment on show_multi_option_variant_groups for
  // the full reasoning (one radio no longer IS one variant; finding the
  // one variant that satisfies two independently-selected option values
  // simultaneously is a different problem). Today's real catalogue has
  // exactly one 2-option product (Masa); this doesn't attempt to
  // generalize to three.
  //
  // Reads the per-sheet variant matrix the liquid template embeds
  // (id/option1/option2/price/available for every real variant) rather
  // than needing a network request -- same "server-renders real data as
  // JSON, JS reads it" pattern as assets/makc-catalogue.js.
  function getMultiOptionMatrix(sheetEl) {
    var matrixEl = sheetEl.querySelector('[data-makc-variant-matrix]');
    if (!matrixEl) return [];
    try {
      return JSON.parse(matrixEl.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  // The hidden proxy radio (data-makc-resolved-variant, see the liquid
  // template's own comment) is the ONLY thing this function ever
  // touches to communicate a result -- it deliberately does not call
  // updateAddButtonPrice's caller-facing sibling logic directly, so
  // updateAddButtonPrice and the Add-click handler stay completely
  // unaware that a multi-option product is even a thing; both just see
  // "a checked radio with data-variant-price-cents," exactly as they
  // already do for the single-option case.
  //
  // Not fully selected yet (either group has no checked radio): clears
  // the proxy and re-enables the Add button -- the existing price/
  // cart-submission code already falls back to base price / the default
  // variant id whenever no [data-variant-price-cents] radio is checked,
  // so "don't guess at a partial match" needs no extra branch here.
  //
  // Both selected: looks up the one variant whose option1/option2 both
  // match, mirrors it onto the proxy. A sold-out match disables the Add
  // button and swaps its text to "Sold out" instead of a price --
  // there's no single radio to disable the way the single-option case
  // does (a bare "6" or "With" isn't itself sold out, only a specific
  // combination might be), so the Add button is the one real UI element
  // that represents "the fully-specified purchase intent" here.
  function resolveMultiOptionVariant(sheetEl) {
    var resolvedRadio = sheetEl.querySelector('[data-makc-resolved-variant]');
    if (!resolvedRadio) return;

    var addButton = sheetEl.querySelector('[data-makc-product-sheet-add]');
    var group1Selected = sheetEl.querySelector('[data-variant-option-group="1"] .makc-product-sheet__modifier-radio:checked');
    var group2Selected = sheetEl.querySelector('[data-variant-option-group="2"] .makc-product-sheet__modifier-radio:checked');

    function clearResolvedVariant() {
      resolvedRadio.checked = false;
      resolvedRadio.value = '';
      resolvedRadio.removeAttribute('data-variant-price-cents');
      if (addButton) {
        addButton.disabled = false;
        addButton.classList.remove('makc-product-sheet__add--disabled');
      }
      updateAddButtonPrice(sheetEl);
    }

    if (!group1Selected || !group2Selected) {
      clearResolvedVariant();
      return;
    }

    var matrix = getMultiOptionMatrix(sheetEl);
    var match = matrix.filter(function (variant) {
      return variant.option1 === group1Selected.value && variant.option2 === group2Selected.value;
    })[0];

    // Shouldn't happen against real data (every combination in Masa's
    // own catalogue exists as a real variant), but fails safely rather
    // than silently adding the wrong thing if it ever does.
    if (!match) {
      clearResolvedVariant();
      return;
    }

    resolvedRadio.value = match.id;
    resolvedRadio.setAttribute('data-variant-price-cents', match.price);
    resolvedRadio.checked = true;

    if (!match.available) {
      if (addButton) {
        addButton.disabled = true;
        addButton.classList.add('makc-product-sheet__add--disabled');
        addButton.textContent = 'Sold out';
      }
      return;
    }

    if (addButton) {
      addButton.disabled = false;
      addButton.classList.remove('makc-product-sheet__add--disabled');
    }
    updateAddButtonPrice(sheetEl);
  }

  var multiOptionRadios = document.querySelectorAll('[data-variant-option-value]');
  multiOptionRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var sheetEl = radio.closest('.makc-product-sheet');
      if (!sheetEl) return;
      resolveMultiOptionVariant(sheetEl);
    });
  });

  // Cross-group dependency: a modifier option's raw metaobject value can
  // carry a "RequiredOptionValue|Display text" prefix (see
  // snippets/makc-product-sheet.liquid), scoping that option to one
  // specific variant selection -- e.g. Jollof Rice Tray with Protein's
  // "Protein - Tray" options are each scoped to one Size. Generic, not
  // hardcoded to that product: runs for any sheet and simply does
  // nothing if it has no [data-requires-option-value] options to
  // filter. Scoped to this build's single-variant-option limitation the
  // same way price reactivity is -- one variant group per sheet, so
  // "the selected variant value" is unambiguous. Factored into a named
  // function (not just a 'change' listener body) so resetSheet() below
  // can also call it directly with selectedValue = null, restoring
  // every scoped option/hint to its true initial state on reopen --
  // the exact same logic that already correctly handles "no variant
  // selected yet" during normal use handles "nothing selected anymore"
  // on reset for free, no separate reset-specific branch needed.
  function filterScopedOptions(sheetEl, selectedValue) {
    var scopedOptions = sheetEl.querySelectorAll('[data-requires-option-value]');
    var scopedContainers = new Set();
    scopedOptions.forEach(function (option) {
      var matches = option.getAttribute('data-requires-option-value') === selectedValue;
      option.hidden = !matches;
      if (!matches) {
        var scopedRadio = option.querySelector('.makc-product-sheet__modifier-radio');
        // Hiding a radio doesn't uncheck it -- leaving a now-invalid
        // selection checked while invisible would be a real stale-state
        // bug, so it's cleared explicitly.
        if (scopedRadio && scopedRadio.checked) scopedRadio.checked = false;
      }
      var container = option.closest('.makc-product-sheet__modifier-options');
      if (container) scopedContainers.add(container);
    });

    // Sync each scoped group's "select X first" hint and its "Choose
    // one" helper (see the liquid template's data-makc-modifier-
    // empty-hint / data-makc-modifier-choose-hint) to whether it now
    // has any visible option at all -- mutually exclusive, both driven
    // by the same check, so exactly one ever shows: the hint while a
    // scoped group has zero visible options (the real "nothing selected
    // yet" state -- also true right after a reset), "Choose one" the
    // instant a match exists. Checks specifically among the group's OWN
    // scoped options, not any option in the container, so this stays
    // correct even if a group ever mixes scoped and unscoped options.
    scopedContainers.forEach(function (container) {
      var anyVisible = container.querySelector('[data-requires-option-value]:not([hidden])');
      var hint = container.parentElement.querySelector('[data-makc-modifier-empty-hint]');
      var chooseHint = container.parentElement.querySelector('[data-makc-modifier-choose-hint]');
      if (hint) hint.hidden = !!anyVisible;
      if (chooseHint) chooseHint.hidden = !anyVisible;
    });
  }

  // Options needing a match start hidden server-side (see the liquid
  // template) rather than this waiting for a change event to hide them
  // -- "no variant selected yet" is a real, common initial state (no
  // variant is pre-selected), and treating it as "nothing matches" this
  // way needs no separate branch here.
  variantRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var sheetEl = radio.closest('.makc-product-sheet');
      if (!sheetEl) return;
      filterScopedOptions(sheetEl, radio.getAttribute('data-option-value'));
    });
  });

  // Special instructions character counter -- UI/counting only, per
  // this step's scope (no submission/persistence logic yet). maxlength
  // on the textarea itself is the real enforcement; this just keeps the
  // visible counter in sync as the user types.
  var instructionsInputs = document.querySelectorAll('[data-makc-instructions-input]');
  instructionsInputs.forEach(function (input) {
    var counter = input.parentElement.querySelector('[data-makc-instructions-counter]');
    if (!counter) return;
    var max = input.getAttribute('maxlength');
    input.addEventListener('input', function () {
      counter.textContent = input.value.length + '/' + max;
    });
  });

  // Composes the pieces defined above into the actual "fresh,
  // unconfigured state" open() resets to on every open (see its own
  // comment) -- quantity back to 1, every radio unchecked, scoped
  // options/hints back to their true initial state (reusing
  // filterScopedOptions with no selection, exactly like first page
  // load), Special instructions cleared, and both error states (step C
  // required-field, step D cart) hidden. Function declarations hoist
  // within this IIFE, so open() (defined earlier, at the top) can
  // reference this safely despite the textual order.
  function resetSheet(sheet) {
    var countEl = sheet.querySelector('[data-makc-stepper-count]');
    if (countEl) countEl.textContent = '1';

    sheet.querySelectorAll('.makc-product-sheet__modifier-radio').forEach(function (radio) {
      radio.checked = false;
    });
    filterScopedOptions(sheet, null);

    var instructionsInput = sheet.querySelector('[data-makc-instructions-input]');
    if (instructionsInput) {
      instructionsInput.value = '';
      var counter = instructionsInput.parentElement.querySelector('[data-makc-instructions-counter]');
      if (counter) counter.textContent = '0/' + instructionsInput.getAttribute('maxlength');
    }

    setValidationState(sheet, []);
    var cartErrorEl = sheet.querySelector('[data-makc-cart-error]');
    if (cartErrorEl) cartErrorEl.hidden = true;

    // Reuses the same function live selection changes call, rather than
    // a separate reset-specific branch -- with both option groups just
    // cleared above, this naturally takes its own "not fully selected"
    // path, which already clears the resolved-variant proxy and
    // re-enables the Add button (undoing a sold-out disable left over
    // from this sheet's last open). A safe no-op on every other sheet:
    // it returns immediately when no [data-makc-resolved-variant] proxy
    // exists.
    resolveMultiOptionVariant(sheet);

    updateAddButtonPrice(sheet);
  }
})();
